export default __webpack_public_path__ + "static/media/quote-icon.935cd7e1.svg";